import { UserActionTypes } from "./user.types";

const INITIAL_STATE = {
  currentUser: null,
  sessionExpired: false,
  sessionExpiredReason: null,
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UserActionTypes.SET_CURRENT_USER:
      return {
        ...state,
        currentUser: action.payload,
        sessionExpired: false,
        sessionExpiredReason: null,
      };

    case UserActionTypes.SESSION_EXPIRED:
      return {
        ...state,
        currentUser: null,
        sessionExpired: true,
        sessionExpiredReason: action.payload ?? null,
      };

    case UserActionTypes.CLEAR_SESSION_EXPIRED:
      return {
        ...state,
        sessionExpired: false,
        sessionExpiredReason: null,
      };

    case UserActionTypes.UPDATE_TOKEN:
      return {
        ...state,
        currentUser: state.currentUser
          ? { ...state.currentUser, token: action.payload }
          : null,
      };

    case UserActionTypes.UPDATE_DISTROS:
      return {
        ...state,
        currentUser: state.currentUser
          ? { ...state.currentUser, distros: action.payload }
          : null,
      };

    default:
      return state;
  }
};

export default userReducer;
